import React from "react";
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import {Box, FormHelperText, LinearProgress} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {inputChangedHandler} from "../../shared/utility";
import Grid from "@material-ui/core/Grid";


const useStyles = makeStyles((theme) => ({

    wrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
    },
    uploadButton: {
        cursor: "pointer",
    },
    uploadText: {
        marginLeft: theme.spacing(2),
        color: "#00AEEF"
    },
    hidden: {
        display: "none"
    },
    imageUploader: {

    },
    imageLabel: {
        fontSize: '12px',
        lineHeight: '15px',
        color: '#96979C',
        paddingTop: '1px'
    }

}));

export default function ImageUploader(props) {
    const classes = useStyles();
    const uploadedImage = React.useRef(null);
    const imageUploader = React.useRef(null);
    const [isUpload, setIsUpload] = React.useState(false);

    const handleImageUpload = (e) => {
        const [file] = e.target.files;
        if (file) {
            const reader = new FileReader();
            const {current} = uploadedImage;
            if (current)
                current.file = file;
            reader.onload = e => {
                const updatedFormState = inputChangedHandler(props.formState, props.setFormState, e.target.result, props.datakey, true, e);
                if (!updatedFormState.controls[props.datakey].valid) {
                    updatedFormState.controls[props.datakey].value = ''; //props.formState.controls[props.datakey].value;
                    props.setFormState(updatedFormState);
                    props.onError && props.onError({ key: props.datakey, formState: updatedFormState });
                    return ;
                }
                if (current)
                    current.src = e.target.result;
                props.onLoad && props.onLoad({ key: props.datakey, data: e.target.result, isUpload, setIsUpload, formState: updatedFormState });    
            };
            reader.readAsDataURL(file);
        }
    };

    let element;

    const hideImage = (props.formState.controls[props.datakey].value) ? false : true

    if (props.type === 'newCarPhotos') {
        const control = props.formState.controls[props.datakey];
        const labelClasses = [classes.imageLabel];
        control.valid || (labelClasses.push('Mui-error MuiFormHelperText-root'));
        element = (
            <Grid item xs={4} className={(isUpload ? 'disabled' : '')}>
                <Grid container direction="column" className={classes.imageUploader}>
                    <Grid item align="center">
                        <Box display="flex"

                            alignItems="center"
                            justifyContent="center"
                            css={{height: 90, width: 122}}
                            border={1}
                            onClick={() => {
                                return isUpload ? null : imageUploader.current.click()
                            }}
                            className={classes.uploadButton}
                        >
                            <PhotoCameraIcon className={!hideImage ? classes.hidden : ''}/>
                            <img
                                ref={uploadedImage}
                                style={{
                                    width: "122px",
                                    height: "90px"
                                }}
                                alt={props.formState.controls[props.datakey].label}
                                src={props.formState.controls[props.datakey].value}
                                className={hideImage ? classes.hidden : ''}/>
                        </Box>

                        {isUpload && <LinearProgress/>}
                    </Grid>
                    <Grid item className={labelClasses.join(' ')}>
                        {props.formState.controls[props.datakey].label}
                    </Grid>
                </Grid>
            </Grid>
        )
    } else if (props.type === 'carPhotos') {
        element = (
            <Grid item xs={4}>
                <Grid container direction="column" className={classes.imageUploader}>
                    <Grid item align="center">
                        <Box display="flex"
                             alignItems="center"
                             justifyContent="center"
                             css={{height: 90, width: 122}}
                             border={1}
                             onClick={() => imageUploader.current.click()}
                             className={classes.uploadButton}
                        >
                            <PhotoCameraIcon className={!hideImage ? classes.hidden : ''}/>
                            <img
                                ref={uploadedImage}
                                style={{
                                    width: "122px",
                                    height: "90px"


                                }}
                                alt={props.formState.controls[props.datakey].label}
                                src={props.formState.controls[props.datakey].value}
                                className={hideImage ? classes.hidden : ''}/>
                        </Box>

                    </Grid>
                    <Grid item className={classes.imageLabel}>
                        {props.formState.controls[props.datakey].label}
                    </Grid>
                </Grid>
            </Grid>

        )

    } else {
        element = (
            <div onClick={() => imageUploader.current.click()} className={classes.uploadButton}>
                <Box display="flex" alignItems="center"
                     justifyContent="center"><PhotoCameraIcon/><span className={classes.uploadText}>
                Add/Edit Photo</span>
                </Box>

            </div>
        )
    }
    return (
        <React.Fragment>
            <input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                ref={imageUploader}
                style={{
                    display: "none"
                }}
            />

            {element}

        </React.Fragment>
    );
}